__turbopack_context__.v({
  "benefits": "E8xX6q_benefits",
  "benefitsIcon": "E8xX6q_benefitsIcon",
  "heightLimit": "E8xX6q_heightLimit",
});
